import { RegionType } from '@wix/shoutout-email-model-v3';
import * as cssUtils from '../../utils/css-utils';
export var getHtmlSection = function (_a) {
    var region = _a.region, css = _a.css;
    if (region.type !== RegionType.Html) {
        throw Error('Html must be passed');
    }
    var rules = [css['so-global-region']];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    return {
        html: region.data.html,
        cssClass: mobileCssClass,
    };
};
//# sourceMappingURL=get-html-section.js.map